@let referentiel = this.referentiel();
@if (referentiel) {
  <hlm-resizable-group class="flex size-full">
    <hlm-resizable-panel
      class="m-md border-stroke-neutral-light bg-background-ground flex flex-col rounded-lg border"
      defaultSize="30"
    >
      <div class="border-stroke-neutral-light p-md flex items-center justify-between border-b">
        <div class="gap-sm flex items-center">
          <p class="title-small-semibold text-content-primary">Processus</p>
          @if (estVerrouille()) {
            <app-chip label="Verrouillé" variant="warning" />
          }
        </div>
        @if (peutModifier()) {
          <button (click)="ajouterPhase()" variant="secondary" hlmBtn size="xxl">
            <ng-icon name="lucidePlus"></ng-icon>
          </button>
        }
      </div>
      @if (phases().length < 1 && !peutModifier()) {
        <app-empty-state title="Pas de processus disponible">
          <span class="text-content-secondary text-center">
            Il semble que rien n’ait été renseigné pour le Processus. Contactez l’administrateur pour déverrouiller le
            Référentiel et ajouter des éléments.
          </span>
        </app-empty-state>
      } @else if (phases().length < 1 && peutModifier()) {
        <div class="text-center">
          <app-empty-state title="Aucune phase" icone="lucidePlus">
            <span class="text-content-secondary text-center">
              Commencez par créer votre première phase pour commencer à structurer le processus.
            </span>

            <button (click)="ajouterPhase()" hlmBtn variant="secondary">
              <ng-icon name="lucidePlus" />
              Ajouter une phase
            </button>
          </app-empty-state>
        </div>
      } @else {
        <div class="m-md flex flex-col">
          <span class="text-content-secondary component-small-semibold">Légende :</span>
          <span class="text-content-secondary component-small-medium">
            <span class="component-small-semibold">A : </span>
            <span>Aptitude ; </span>
            <span class="component-small-semibold">P : </span>
            <span>Production ; </span>
            <span class="component-small-semibold">I : </span>
            <span>Indice de résultats.</span>
          </span>
        </div>
        <div class="h-full overflow-y-auto">
          <app-list-item
            [cdkDropListData]="phases() | trierPar: 'indice'"
            (cdkDropListDropped)="dropPhase($event)"
            gap="16px"
            cdkDropList
            cdkDropListGroup
          >
            @for (phase of phases() | trierPar: 'indice'; track phase.id; let last = $last) {
              <div class="gap-md flex flex-col">
                <app-item-phase
                  [phase]="phase"
                  [phases]="phases()"
                  [referentiel]="referentiel"
                  [cartographie]="cartographie()"
                  [peutModifier]="peutModifier()"
                  (onCreateProduction)="createProduction($event)"
                  (onCreateIndiceResultat)="createIndiceResultat($event)"
                >
                </app-item-phase>
                @if (!last) {
                  <hlm-separator />
                }
              </div>
            }
          </app-list-item>
        </div>
      }
    </hlm-resizable-panel>
    <hlm-resizable-handle />

    <hlm-resizable-panel defaultSize="70">
      <div class="bg-background-ground border-stroke-neutral-light h-full border-l">
        @if (aptitudes().length === 0 && peutModifier()) {
          <app-empty-state title="Aucune aptitude" icone="lucideMousePointerClick">
            <span class="text-content-secondary text-center"
              >Une fois que vous aurez créé des phases, vous pourrez y ajouter des aptitudes. Vous retrouverez ici les
              productions et les indices de résultats de l’aptitude sélectionnée.</span
            >
          </app-empty-state>
        } @else {
          @if (selectedAptitude(); as aptitude) {
            <app-processus-aptitude
              [aptitude]="aptitude"
              [cartographie]="cartographie()"
              [referentiel]="referentiel"
              [phases]="phases()"
              [peutModifier]="peutModifier()"
              (onCreateProduction)="createProduction(aptitude)"
              (onCreateIndice)="createIndiceResultat(aptitude)"
            />
          } @else {
            <app-empty-state title="Aucune aptitude sélectionnée" icone="lucideMousePointerClick">
              <span class="text-content-secondary text-center"
                >Sélectionnez une aptitude pour afficher ses productions, ses indices de résultats et leurs indicateurs
                de performance, et en créer de nouveaux.</span
              >
            </app-empty-state>
          }
        }
      </div>
    </hlm-resizable-panel>
  </hlm-resizable-group>
}
